import { render, staticRenderFns } from "./Google.vue?vue&type=template&id=33cafddb&scoped=true&"
import script from "./Google.vue?vue&type=script&lang=js&"
export * from "./Google.vue?vue&type=script&lang=js&"
import style0 from "./Google.vue?vue&type=style&index=0&id=33cafddb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cafddb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33cafddb')) {
      api.createRecord('33cafddb', component.options)
    } else {
      api.reload('33cafddb', component.options)
    }
    module.hot.accept("./Google.vue?vue&type=template&id=33cafddb&scoped=true&", function () {
      api.rerender('33cafddb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/social/Google.vue"
export default component.exports